<! --
/**
* SuiteCRM is a customer relationship management program developed by SalesAgility Ltd.
* Copyright (C) 2021 SalesAgility Ltd.
*
* This program is free software; you can redistribute it and/or modify it under
* the terms of the GNU Affero General Public License version 3 as published by the
* Free Software Foundation with the addition of the following permission added
* to Section 15 as permitted in Section 7(a): FOR ANY PART OF THE COVERED WORK
* IN WHICH THE COPYRIGHT IS OWNED BY SALESAGILITY, SALESAGILITY DISCLAIMS THE
* WARRANTY OF NON INFRINGEMENT OF THIRD PARTY RIGHTS.
*
* This program is distributed in the hope that it will be useful, but WITHOUT
* ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
* FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
* details.
*
* You should have received a copy of the GNU Affero General Public License
* along with this program.  If not, see http://www.gnu.org/licenses.
*
* In accordance with Section 7(b) of the GNU Affero General Public License
* version 3, these Appropriate Legal Notices must retain the display of the
* "Supercharged by SuiteCRM" logo. If the display of the logos is not reasonably
* feasible for technical reasons, the Appropriate Legal Notices must display
* the words "Supercharged by SuiteCRM".
*/
-->
<div class="card border shadow-sm" *ngIf="bodySubpanels()?.length">
    <div ngbAccordion class="sub-panel-banner" #accordion="ngbAccordion" activeIds="sub-panel-buttons">
        <div ngbAccordionItem id="sub-panel-buttons" class="card" [collapsed]="isCollapsed()">
            <div ngbAccordionHeader class="card-header">
                <div class="d-flex justify-content-between">
                    <div class="d-flex align-items-start sub-panel-banner-header">
                        <a (click)="toggleSubPanels()" class="clickable">
                            <scrm-label labelKey="LBL_RELATIONSHIPS"></scrm-label>
                        </a>
                    </div>

                    <div class="d-flex align-items-center justify-content-end">

                        <div class="row insight-panel" *ngIf="isCollapsed()">
                            <div class="col-auto mr-3 insight-panel-card border-insight"
                                 *ngFor="let subpanelKey of headerSubpanels()"
                                 [ngClass]="{'sub-panel-banner-button-active': subpanels[subpanelKey].show === true}"
                                 (click)="showSubpanel(subpanels[subpanelKey].metadata.name, subpanels[subpanelKey])">
                                <scrm-grid-widget
                                        [config]="getGridConfig(subpanels[subpanelKey])"></scrm-grid-widget>
                            </div>
                        </div>

                        <div class="d-flex align-items-center sub-panel-header-toggle">
                            <a (click)="toggleSubPanels()" class="clickable position-relative">
                                <ng-container *ngIf="isCollapsed()">
                                    <scrm-image
                                            [attr.aria-expanded]="false"
                                            [image]="'chevron-down'"
                                            aria-controls="collapseShowSubPanels"
                                            class="float-right">
                                    </scrm-image>
                                </ng-container>
                                <ng-container *ngIf="!isCollapsed()">
                                    <scrm-image
                                            [attr.aria-expanded]="true"
                                            [image]="'chevron-up'"
                                            aria-controls="collapseShowSubPanels"
                                            class="float-right">
                                    </scrm-image>
                                </ng-container>
                            </a>
                        </div>

                    </div>
                </div>

            </div>
            <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                    <ng-template>
                        <div id="collapseShowSubPanels" class="sub-panel-banner-body d-flex align-items-center justify-content-center border-bottom border-top pt-2 pb-3 ml-2 mr-2 mb-2">
                            <table class="sub-panel-banner-body-table">
                                <tr class="insight-panel sub-panel-banner-body-table-row" *ngFor="let subpanelRow of bodySubpanels()">
                                    <td *ngFor="let subpanelKey of subpanelRow" class="sub-panel-banner-body-table-col">
                                        <ng-container *ngIf="subpanelKey">
                                            <div class="insight-panel-card border-insight pl-2 pr-2"
                                                 [ngClass]="{'sub-panel-banner-button-active': subpanels[subpanelKey].show === true}"
                                                 (click)="showSubpanel(subpanels[subpanelKey].metadata.name, subpanels[subpanelKey])">
                                                <scrm-grid-widget
                                                        [config]="getGridConfig(subpanels[subpanelKey])"></scrm-grid-widget>
                                            </div>
                                        </ng-container>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </ng-template>
                </div>
            </div>

        </div>
    </div>

    <div class="sub-panels {{(isCollapsed() && !openSubpanels()?.length) ? 'pb-1' : ''}}">
        <ng-container *ngFor="let subpanelKey of this.openSubpanels()">
            <ng-container *ngIf="(subpanels[subpanelKey]) as item">
                <scrm-subpanel *ngIf="item.show"
                               [maxColumns$]="maxColumns$"
                               [store]="item"
                               [filterConfig]="filterConfig"
                               [onClose]="getCloseCallBack(subpanelKey, item)"
                               class="sub-panel minimal-table">
                </scrm-subpanel>
            </ng-container>
        </ng-container>

    </div>

</div>
